import React, { useEffect, useState } from "react";
import { Navigate } from "react-router-dom";
import { getAuth, onAuthStateChanged } from "firebase/auth";
import { doc, getDoc } from "firebase/firestore";

import CareersPage from "./CareersPage";
import GlobalSpinner from "../CustomReusables/GlobalSpinner";
import { db } from "../../configs/firebase";
import {
  normalizeUserRole,
  USER_ROLES,
} from "../Profile/constants/userRoles";

const SuperAdminCareersRoute: React.FC = () => {
  const [loading, setLoading] = useState(true);
  const [allowed, setAllowed] = useState(false);
  const [redirectPath, setRedirectPath] = useState("/login");

  useEffect(() => {
    let active = true;

    const unsubscribe = onAuthStateChanged(
      getAuth(),
      async (currentUser) => {
        if (!active) return;

        if (!currentUser) {
          setAllowed(false);
          setRedirectPath("/login");
          setLoading(false);
          return;
        }

        setLoading(true);

        try {
          const userSnapshot = await getDoc(
            doc(db, "users", currentUser.uid)
          );

          const role = userSnapshot.exists()
            ? normalizeUserRole(userSnapshot.data().role)
            : USER_ROLES.GUEST;

          if (!active) return;

          setAllowed(role === USER_ROLES.SUPER_ADMIN);
          setRedirectPath("/dashboard");
        } catch (error) {
          console.error(
            "[CAREERS] Failed to verify Super Admin:",
            error
          );

          if (!active) return;

          setAllowed(false);
          setRedirectPath("/dashboard");
        } finally {
          if (active) setLoading(false);
        }
      }
    );

    return () => {
      active = false;
      unsubscribe();
    };
  }, []);

  if (loading) {
    return (
      <div
        style={{
          minHeight: "240px",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <GlobalSpinner />
      </div>
    );
  }

  if (!allowed) {
    return <Navigate to={redirectPath} replace />;
  }

  return (
    <CareersPage
      mode="admin"
      apiBaseUrl={
        process.env.REACT_APP_API_URL || "http://localhost:5000"
      }
      getAdminToken={async () => {
        const user = getAuth().currentUser;

        if (!user) {
          throw new Error("Administrator authentication required.");
        }

        return user.getIdToken();
      }}
    />
  );
};

export default SuperAdminCareersRoute;